'use client';
import { getUrlGtm } from '@/utils/gtmUtils';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, subtitle, list = [] } = data;
    const { locale = 'us' } = getLocal();
    const prefixCls = 'image-background-card';

    const handleGtmBtn = (val: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'banner_switch',
            position: `Homepage_Swiper_3_${val}`,
            button_name: val,

            __btn_id1: `editor-${id} .bjtxkp-swiper-${val}`,
            __btn_id2: `bjtxkp-swiper-${val}`,
            __btn_type: 'common',
        });
    };
    return (
        <GloLayout className={`editor-image-background-card`} id={id} data={data} floorName="image-background-card">
            <div className="eco-content-v2">
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <h2 className={`${prefixCls}-subtitle`}>{subtitle}</h2>
            </div>

            <div className={`${prefixCls}-list-out`}>
                <Swiper
                    className={`${prefixCls}-swiper`}
                    modules={list.length > 2 ? [Navigation] : []}
                    navigation={
                        list.length > 2
                            ? {
                                  prevEl: `#editor-${id} .bjtxkp-swiper-Left`,
                                  nextEl: `#editor-${id} .bjtxkp-swiper-Right`,
                              }
                            : false
                    }
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    initialSlide={0}
                >
                    {list.map((itemA: any, index: number) => (
                        <SwiperSlide className={`${prefixCls}-item`} key={index}>
                            <EcoLink
                                href={itemA.href}
                                className={`${prefixCls}-item-link GtmModuleData-btn-href bjtxkp-swiper-item-a-${index}`}
                                dataLayer={{
                                    ...getUrlGtm(itemA.rHref, locale, {
                                        list_name: title,
                                        button_name: itemA.title,
                                        product_name: itemA.title,
                                    }),

                                    __btn_id1: `editor-${id} .bjtxkp-swiper-item-a-${index}`,
                                    __btn_id2: itemA.rHref,
                                    __btn_type: 'href',
                                }}
                            >
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className={`${prefixCls}-item-img`} />
                                <div className={`${prefixCls}-item-msg`}>
                                    <div className={`${prefixCls}-item-title`} style={{ color: itemA?.titleColor }}>
                                        {itemA.title}
                                    </div>
                                    <div className={`${prefixCls}-item-desc`}>{itemA.desc}</div>
                                </div>
                            </EcoLink>
                        </SwiperSlide>
                    ))}

                    {list.length > 2 && (
                        <div className={`${prefixCls}-control`}>
                            <div
                                className={`swiper-button-prev GtmModuleData-btn-common bjtxkp-swiper-Left`}
                                data-btn-id="bjtxkp-swiper-Left"
                                onClick={() => handleGtmBtn('Left')}
                            ></div>
                            <div
                                className={`swiper-button-next GtmModuleData-btn-common bjtxkp-swiper-Right`}
                                data-btn-id="bjtxkp-swiper-Right"
                                onClick={() => handleGtmBtn('Right')}
                            ></div>
                        </div>
                    )}
                </Swiper>
            </div>
        </GloLayout>
    );
}
